import { t } from "i18next";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import { setDialog } from "../../../app/appSlice";
import { useAppSelector } from "../../../hooks/hooks";
import { useSecureApplication } from "../../../hooks/KeycloackConnection";
import { useGraph } from "../../../hooks/useGraph";
import { setChangedTopology } from "../editorSlice";

const DeleteDiagram = () => {
  const dispatch = useDispatch();

  const { clearDiagram } = useGraph();

  const { hasAnyPerm } = useSecureApplication();

  const pipelineChanged = useAppSelector(
    (state) => state.editor.changedTopology
  );

  const dialogContent = () => {
    return (
      <>
        <div className="mb-3">
          Etes-vous sûr de vouloir supprimer le graphique ?
        </div>
        {footerDialog()}
      </>
    );
  };

  const footerDialog = () => {
    return (
      <div style={{ float: "right" }}>
        <Button
          label={"ANNULER"}
          onClick={() => dispatch(setDialog(undefined))}
          className="mr-3 p-button-outlined p-button-sm"
        />

        <Button
          id="hook-form"
          onClick={() => {
            clearDiagram();
            dispatch(setDialog(undefined));
            if (!pipelineChanged) dispatch(setChangedTopology(true));
          }}
          type="submit"
          label={"SUPPRIMER"}
          className="p-button-danger p-button-sm"
        ></Button>
      </div>
    );
  };

  return (
    <>
      <Button
        disabled={!hasAnyPerm("pipelines.all", "pipelines_del")}
        className="p-button-text"
        title={t("button.delete")}
        icon="pi pi-trash"
        onClick={() => {
          dispatch(
            setDialog({
              content: dialogContent(),
              title: "Supprimer"
            })
          );
        }}
      ></Button>
    </>
  );
};

export default DeleteDiagram;
